export const CATEGORY_CODES = {
  SVID_PRAVO_NASLED: "SVID_PRAVO_NASLED",
  STATEMENT: "SVID_PODLINNOST_PODPISI",
  ZAVESCHANIE: "ZAVESCHANIE",
  SOVER_EXECUT_NADPIS: "SOVER_EXECUT_NADPIS",
  APPLICATIONS: "APPLICATIONS",
};

// Бэкенд поддерживает только day/month/year; коды совместимы с moment().add.
export const END_DATE_UNITS = [
  { code: "day", label: "День" },
  { code: "month", label: "Месяц" },
  { code: "year", label: "Год" },
];

// Ключ magic-поля текущего дня.
export const DAY_KEY = "day";
// Ключ magic-поля даты окончания.
export const EXPIRATION_DATE_KEY = "expiration_date";

// Ключи magic-полей, для которых доступна вставка даты прописью через дропдаун.
export const DATE_WORD_KEYS = [DAY_KEY, EXPIRATION_DATE_KEY];

// Человекочитаемые подписи ключей дат для вставляемого mention.
export const DATE_FIELD_LABELS = {
  [DAY_KEY]: "День",
  [EXPIRATION_DATE_KEY]: "Дата окончания",
};
